// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__8P0tj","large":"styles_large__1r3mH"};